import React, { useState } from "react";
import styled from "styled-components";
import footer from "../assets/footer.png";
import { FaEnvelope } from "react-icons/fa";
import { motion } from "framer-motion";

export default function SubmitEmail() {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle email submission logic here
    console.log("Email submitted:", email);
  };

  return (
    <StyledSubmitEmail>
      <motion.div 
        className="content"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Stay Wrooted with us 
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          Join our community of changemakers restoring ecosystems around the world. 
          <br />
          One tree at time. 
        </motion.p>
        <motion.form 
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="input-wrapper">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <motion.button 
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              SUBMIT
            </motion.button>
          </div>
        </motion.form>
      </motion.div>
    </StyledSubmitEmail>
  );
}

const StyledSubmitEmail = styled.section`
  width: var(--section-width);
  margin: var(--section-margin) auto;
  background: url(${footer}) no-repeat center center;
  background-size: cover;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  padding: 4rem 2rem;
  text-align: center;
  color: white;

  .content {
    max-width: 600px;
    margin: 0 auto;

    h1 {
      font-size: 3rem;
      margin-bottom: 1rem;
      color: white;
    }

    p {
      font-size: 1.2rem;
      margin-bottom: 2rem;
      line-height: 1.6;
      color: white;
    }

    form {
      .input-wrapper {
        position: relative;
        max-width: 500px;
        margin: 0 auto;
        display: flex;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 50px;
        padding: 0;

        .input-icon {
          position: absolute;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
          color: white;
          font-size: 1.2rem;
        }

        input {
          flex: 1;
          border: none;
          padding: 0 1rem 0 3rem;
          height: 45px;
          border-radius: 50px;
          font-size: 1rem;
          outline: none;
          background: transparent;
          color: white;

          &::placeholder {
            color: rgba(255, 255, 255, 0.7);
          }
        }

        button {
          background: #c1e02e;
          color: black;
          border: none;
          height: 45px;
          padding: 0 2rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            background: #aac728;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 3rem 1rem;
    .content {
      h1 {
        font-size: 2.5rem;
      }

      p {
        font-size: 1rem;
      }

      form .input-wrapper {
        flex-direction: row;
        gap: 0.5rem;
        padding: 0;

        input {
          width: 100%;
          text-align: left;
          padding: 0 1rem 0 3rem;
        }

        button {
          width: auto;
          height: 45px;
          padding: 0 1.5rem;
          font-size: 0.9rem;
        }
      }
    }
  }

  @media (max-width: 480px) {
    min-height: 400px;
    padding: 2rem 1rem;
    .content {
      h1 {
        font-size: 2rem;
      }

      p {
        font-size: 0.9rem;
        margin-bottom: 1.5rem;
      }

      form .input-wrapper {
        gap: 0.3rem;
        padding: 0;

        input {
          padding: 0 1rem 0 2.5rem;
        }

        .input-icon {
          left: 15px;
          font-size: 1rem;
        }

        button {
          height: 45px;
          padding: 0 1.2rem;
          font-size: 0.8rem;
        }
      }
    }
  }
`;